export const getJSON = (name) => require(`../public/${name}.json`);

export const getCountries = () => getJSON('country');
